import $ from 'jquery';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

const tables = $('.editor-styles table');

function initResponsiveTables() {
	tables.each(function() {
		$(this).wrap('<div class="responsive-table"><div class="responsive-table__inner"</div>');
	});
}

function handleTablesView(e) {
	tables.each(function() {
		var table = $(this);
		var container = table.closest('.responsive-table');
		if(table.width() > container.width()) {
			container.addClass('overflow');
		} else {
			container.removeClass('overflow');
		}
	});
}

document.addEventListener('DOMContentLoaded', initResponsiveTables);
window.addEventListener('resize', helpers.debounce(handleTablesView));
